// Test IDs for scanner component

export const SCANNER_WRAPPER_TEST_IDS = {
  CONTAINER: 'scanner-wrapper',
} as const;

